import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import logo from "../assets/logo.png";
import { checkAuthOnce, getCachedAuthStatus } from "../utils/auth";

const loaderStyles = {
  wrapper: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, var(--blue-light) 0%, var(--blue-dark) 100%)",
    fontFamily: "'Montserrat', sans-serif",
    gap: 24,
  },
  card: {
    background: "#ffffff",
    borderRadius: "1.25rem",
    boxShadow: "0 12px 28px rgba(0,0,0,0.12)",
    padding: "2.5rem 3rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 20,
  },
  logo: {
    height: 44,
    width: "auto",
  },
  spinner: {
    width: 28,
    height: 28,
    border: "3px solid #e0e0e0",
    borderTop: "3px solid var(--blue-dark, #2e3192)",
    borderRadius: "50%",
    animation: "protectedRouteSpin 0.8s linear infinite",
  },
  text: {
    fontSize: "0.9rem",
    color: "var(--text-dark, #231f20)",
    fontWeight: 500,
    margin: 0,
  },
};

const spinKeyframes = `@keyframes protectedRouteSpin { to { transform: rotate(360deg); } }`;

export default function ProtectedRoute({ children }) {
  const cached = getCachedAuthStatus();
  const [isAuthenticated, setIsAuthenticated] = useState(cached ?? false);
  const [isLoading, setIsLoading] = useState(cached === null);

  useEffect(() => {
    if (getCachedAuthStatus() !== null) {
      setIsAuthenticated(getCachedAuthStatus());
      setIsLoading(false);
      return;
    }
    checkAuthOnce().then((status) => {
      setIsAuthenticated(status);
      setIsLoading(false);
    });
  }, []);

  if (isLoading)
    return (
      <>
        <style>{spinKeyframes}</style>
        <div style={loaderStyles.wrapper} aria-busy="true">
          <div style={loaderStyles.card}>
            <img src={logo} alt="dAItaflow" style={loaderStyles.logo} />
            <div style={loaderStyles.spinner} />
            <p style={loaderStyles.text}>Verifying your session...</p>
          </div>
        </div>
      </>
    );
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children || <Outlet />;
}
